import ModalService from '/@/modules/core/ui/services/ModalService';

export const ModalMixin = {
  methods: {
    close(delay = null, callback = null) {
      if (!delay) {
        ModalService.closeWithComponent(this);
        callback?.();
        return;
      }

      setTimeout(() => {
        ModalService.closeWithComponent(this);
        callback?.();
      }, delay);
    }
  }
};
